import * as React from 'react'

import styled from '@emotion/styled'

import Header from './Header'
import Icon from './Icon'

export type TooltipProps = {
  children: React.ReactNode
  onClick: () => void
}

const ChameleonHeader = styled(Header)`
  color: unset;
`

const IconContainer = styled.span`
  margin-right: 0.5rem;
  display: flex;
  align-items: center;
`

const Container = styled.div`
  display: inline-flex;
  font-size: 1rem;
  line-height: 1.5rem;
  color: ${props => props.theme.colors.link};
  cursor: pointer;
  width: fit-content;

  :hover {
    color: ${props => props.theme.colors.primaryButtonHover};
  }

  ${props => props.theme.motion.standardTransition}

  :active {
    ${props => props.theme.motion.standardActiveState}
    color: ${props => props.theme.colors.primaryButtonActive};
  }
`

export const Tooltip = React.forwardRef<HTMLDivElement, TooltipProps>(({ children, onClick }, ref) => (
  <Container ref={ref} onClick={onClick} role="button" aria-label="Open tooltip">
    <IconContainer>
      <Icon name="info" />
    </IconContainer>
    <ChameleonHeader variant="small-title" color="tooltip">
      {children}
    </ChameleonHeader>
  </Container>
))

export default Tooltip
